import { TemplateRef } from '@angular/core';

export class HeaderTable {
  prop: string;
  name: string;
  visible: boolean;
  template?: TemplateRef<any>;
}
